import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { FinancialTransactionDto } from '@/features/dashboard/financialTransactions/types/FinancialTransactionDto.ts';
import { FinancialTransactionListDto } from '@/features/dashboard/financialTransactions/types/FinancialTransactionListDto.ts';
import {
  CreateFinancialTransactionRequestDto,
  UpdateFinancialTransactionRequestDto,
} from '@/features/dashboard/financialTransactions/types/FinancialTransactionRequestDto.ts';

const financialTransactionsApi = {
  getTableDefinition: (): Promise<TableDefinitionDto> =>
    fetchPrivateApi('GET', 'financial-transactions/table-definition'),
  getAll: (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<FinancialTransactionListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return fetchPrivateApi<PagedDto<FinancialTransactionListDto>>(
      'POST',
      `financial-transactions/all?${params.toString()}`,
      filterCriteria,
    );
  },
  create: (
    request: CreateFinancialTransactionRequestDto,
  ): Promise<FinancialTransactionDto> =>
    fetchPrivateApi('POST', 'financial-transactions', request),
  update: (
    id: string,
    request: UpdateFinancialTransactionRequestDto,
  ): Promise<FinancialTransactionDto> =>
    fetchPrivateApi('PUT', `financial-transactions/${id}`, request),
  delete: (id: string): Promise<void> =>
    fetchPrivateApi('DELETE', `financial-transactions/${id}`),
  /** Odpina jedną alokację; transakcja zostaje, kwota wraca do nierozdysponowanych. */
  deleteAllocation: (
    id: string,
    allocationId: string,
  ): Promise<FinancialTransactionDto> =>
    fetchPrivateApi(
      'DELETE',
      `financial-transactions/${id}/allocations/${allocationId}`,
    ),
  getById: (id: string): Promise<FinancialTransactionDto> =>
    fetchPrivateApi('GET', `financial-transactions/${id}`),
  recalculatePaymentStatuses: (): Promise<void> =>
    fetchPrivateApi(
      'POST',
      'financial-transactions/recalculate-payment-statuses',
    ),
};

export default financialTransactionsApi;
